import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as OrdersActions from "./../../../store/actions/Orders";
import Details from "../../../components/Orders/Details";
import TopActionBar from "../../../components/Orders/TopActionBar";
import { getPath, isValNull } from "../../../utils";

const Show = ({
  getOrderDetails,
  orderDetails,
  allMenuActions,
  resetOrderDetails,
  actionTypes,
  menus,
}) => {
  const { id } = useParams();
  const [orderMeta, setOrderMeta] = useState({});
  const [reasonCodes, setReasonCodes] = useState({});

  const loadOrder = (id) => {
    resetOrderDetails();
    getOrderDetails(id).then((res) => {
      let trip_id,driver_id,state;
      trip_id = getPath(res, "trip.trip_id");
      driver_id = getPath(res, "trip.driver_id");
      state = getPath(res, "order.state");
      if (!isValNull(trip_id)) {
        setOrderMeta({
          id: id,
          trip_id: trip_id,
          driver_id: driver_id,
          state: state          
        });
      }
    });

    actionTypes(id).then((res) => {
       var action_type_with_reason_codes = res?.action_type_with_reason_codes || [];
       var all_reason_codes = {};
       for (let i = 0; i < action_type_with_reason_codes.length; i++) {
         var action_type_with_reason = action_type_with_reason_codes[i];
         var action_type = action_type_with_reason?.action_type;
         var reason_codes = action_type_with_reason?.reason_codes?.reason_codes;
         if (action_type === 1) {
           all_reason_codes["reason_codes_for_cancel_order"] = reason_codes;
         } else if (action_type === 2) {
           all_reason_codes["reason_codes_for_force_complete_order"] = reason_codes;
         } else if (action_type === 3) {
           all_reason_codes["reason_codes_for_unassign_order"] = reason_codes;
         }
       }
       setReasonCodes(all_reason_codes);
    });
  };
  useEffect(() => {
    if (getPath(orderDetails, "order.order_id") !== id) {
      loadOrder(id);
    }
  }, [id]);

  return (
    <div>
      <TopActionBar
        id={id}
        orderMeta={orderMeta}
        reasonCodes = {reasonCodes}
        allMenuActions={allMenuActions}
        refresh={loadOrder}
      />
      <Details details={orderDetails} menus={menus}/>
    </div>
  );
};

function mapStateToProps(state) {
  const { Orders, MenuActions } = state;
  return {
    orderDetails: Orders.Order,
    allMenuActions: MenuActions.allMenuActions,
    menus: MenuActions.menus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOrderDetails: bindActionCreators(
      OrdersActions.getOrderDetails,
      dispatch
    ),
    resetOrderDetails: bindActionCreators(
      OrdersActions.resetOrderDetails,
      dispatch
    ),
    actionTypes: bindActionCreators(OrdersActions.getActionTypesWithReasons, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Show);
